// test36
(36 && 0);
